module.exports = __webpack_public_path__ + "static/media/bank-acc.0a3e29cf.svg";